export default "__VITE_ASSET__Chq24GVT__"